import * as React from "react";

const IconPaginationArrowRightLightDisabled: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#FFF" d="M17.315 8.182l.685-.68-.685-.68L11.127.68 10.442 0 9.077 1.356l.684.679 4.537 4.507H0v1.92h14.294l-4.537 4.503-.684.679L10.438 15l.685-.68z" opacity=".33"/></svg>;
};

export default React.memo(IconPaginationArrowRightLightDisabled);
